import BaseComponent from '../BaseComponent';
import AccordionSummary from "@mui/material/AccordionSummary";
import {ExpandMore} from "@mui/icons-material";

class AccordionItemHead extends BaseComponent {

  render() {
    return <AccordionSummary expandIcon={<ExpandMore/>}>
      {this.props.children}
    </AccordionSummary>;
  }
}

export default AccordionItemHead;